import React, { PropTypes } from 'react';

export class ArrowDown extends React.Component {

  static propTypes = {
    color: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string
  };

  getStrokeColor () {
    switch (this.props.color) {
      case 'primary':
        return '#00587c';
      case 'blue-light':
        return '#b2cdd7';
      case 'white':
        return '#ffffff';
      default:
        return '#000000';
    }
  }

  render () {
    const stroke = typeof this.props.color === 'undefined'
      ? '#00587c'
      : this.getStrokeColor();

    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={this.props.width || '20'}
        height={this.props.height || '12'}
        viewBox="0 0 20 12"
        fill="none"
      >
        <path
          d="M1.5 1.5L10 10L14.25 5.75L18.5 1.5"
          stroke={stroke}
          strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export default ArrowDown;



/** WEBPACK FOOTER **
 ** ./src/components/svg/arrow-down.js
 **/